import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';

const LocaleContext = createContext();
const LOCALE_KEY = 'gl.locale';

const messages = {
  en: {
    brand_title: 'GL Compra de Ouro',
    customers: 'Customers',
    search_placeholder: 'Search by name, info, or phone',
    signed_in_as: 'Signed in as',
    logout: 'Logout',
    current_balance: 'Current Balance',
    make_transaction: 'Make a Transaction',
    type: 'Type',
    deposit: 'Deposit',
    withdraw: 'Withdraw',
    amount: 'Amount',
    description: 'Description',
    description_placeholder: 'e.g., Deposit from gold sale',
    date: 'Date',
    add_transaction: 'Add Transaction',
    transaction_history: 'Transaction History',
    no_transactions: 'No transactions yet',
    no_customers: 'No customers found',
    select_customer: 'Select a customer to view details',
    // Customers
    add_client: 'Add Client',
    new_client: 'New Client',
    edit_client: 'Edit Client',
    name: 'Name',
    email: 'Email',
    phone: 'Phone',
    additional_info: 'Additional Info',
    cancel: 'Cancel',
    create: 'Create',
    save: 'Save',
    edit: 'Edit',
    delete: 'Delete',
    delete_confirm: 'Delete this customer? This will also remove their transactions.',
    delete_tx_confirm: 'Delete this transaction?',
    edit_transaction: 'Edit Transaction',
    saving: 'Saving…',
    invalid_amount: 'Invalid amount',
    all_clients_total: 'All Clients Balance',
    transaction_statement: 'Transaction Statement',
    generated: 'Generated',
    unknown_customer: 'Unknown Customer',
    current_balances: 'Current Balances',
    no_wallets: 'No wallets',
    page: 'Page',
    of: 'of',
    no_transactions_found_for_customer: 'No transactions found for this customer.',
    amount: 'Amount',
    export_pdf: 'Export PDF',
    exporting: 'Exporting…',
    export_saldos: 'Export Saldos',
    saldos_statement: 'Client Balances',
    no_clients_with_balance: 'No clients with a non-zero balance.',
    // Transaction History
    client: 'Client',
    currency: 'Currency',
    balance: 'Balance',
    all: 'All',
    today: 'Today',
    last_7_days: 'Last 7 days',
    last_30_days: 'Last 30 days',
    this_month: 'This month',
    all_time: 'All time',
    date_from: 'Date from',
    date_to: 'Date to',
    search: 'Search',
    loading: 'Loading…',
    results: 'results',
    no_results: 'No results',
    close: 'Close',
    // Login
    sign_in_to_continue: 'Sign in to continue',
    username: 'Username',
    password: 'Password',
    sign_in: 'Sign in',
    demo_credentials: 'Demo credentials:',
    // Module picker
    choose_module: 'Choose a module',
    choose_module_desc: 'Select which area of the business you want to work on.',
    module_custody: 'Custody',
    module_custody_desc: 'Manage client money custody (USD, EUR, SRD): deposits, withdrawals, balances and transaction history.',
    module_gold: 'Gold',
    module_gold_desc: 'Track physical gold per client and per purity (teor). Deposits, withdrawals and history.',
    module_loans: 'Loans',
    module_loans_desc: 'Manage client loans, interest and repayment schedules.',
    coming_soon: 'Coming soon',
    back_to_modules: 'Back to modules',
    // Gold module
    gold_holdings: 'Gold Holdings',
    no_gold_lots: 'No gold for this client yet',
    make_gold_transaction: 'Make a Gold Transaction',
    purity: 'Purity (Teor)',
    purity_hint_deposit: 'A new purity creates a new lot. Same purity merges into the existing lot.',
    purity_hint_withdraw: 'Withdrawals are taken from a single lot. Purities are never mixed.',
    withdraw_from_lot: 'Withdraw from lot',
    select_lot_placeholder: 'Select a lot...',
    select_lot_first: 'Please select a lot to withdraw from.',
    insufficient_gold_in_lot: 'Not enough gold in this lot.',
    invalid_purity: 'Purity must be between 0 and 100.',
    lot: 'Lot',
    total: 'Total',
    unit: 'Unit',
    all_clients_gold_total: 'All Clients Gold',
    gold_statement: 'Gold Statement',
    // Gold Purchase ledger module
    module_gold_purchase: 'Gold Purchases',
    module_gold_purchase_desc: 'Daily gold buy-log: weight, price, totals and client payouts with running balance.',
    module_kassa: 'Register',
    module_kassa_desc: 'Daily cash register: set opening balances (USD/SRD/EUR) and log payments and receipts.',
    kassa_opening: 'Opening Balance',
    kassa_set_opening: 'Set Opening',
    kassa_not_set: 'not set for this day',
    kassa_saldo: 'Balance',
    kassa_add_transaction: 'Add Transaction',
    kassa_pagamento: 'Payment',
    kassa_recebido: 'Received',
    kassa_add_line: 'Add Line',
    kassa_confirm: 'Confirm',
    kassa_need_amount: 'Enter an amount in at least one currency.',
    kassa_gold_tab: 'Gold',
    kassa_gold_paid: 'Gold paid',
    kg_other_day: 'That note is on another day',
    kassa_close_title: 'Close Register',
    kassa_close_save: 'Save Closing',
    kassa_closed: 'Closed',
    kassa_bill: 'Bill',
    kassa_count: 'Count',
    kassa_counted: 'Counted',
    kassa_difference: 'Difference',
    kassa_unlock: 'Unlock',
    kassa_reopen_confirm: 'Reopen this day for editing?',
    kassa_locked_note: 'Register closed — unlock to make changes.',
    prev_day: 'Previous day',
    next_day: 'Next day',
    gold_purchase: 'Gold Purchases',
    gp_today: 'Today',
    gp_opening_balance: 'Opening Balance',
    gp_closing_balance: 'Closing Balance',
    gp_set_opening: 'Set opening balance',
    gp_exchange_rate: 'Exchange Rate (USD → SRD)',
    gp_default_rate: 'Default rate',
    gp_note: 'Note #',
    gp_grams: 'Grams',
    gp_price: 'Price/g',
    gp_total_usd: 'Total USD',
    gp_total_srd: 'Total SRD',
    gp_rate: 'Rate',
    gp_paid_usd: 'Paid USD',
    gp_paid_srd: 'Paid SRD',
    gp_paid_eur: 'Paid EUR',
    gp_add_row: 'Add purchase',
    gp_no_rows: 'No purchases for this day yet',
    gp_new_row: 'New',
    gp_edit: 'Edit',
    gp_confirm: 'Confirm',
    gp_print: 'Print',
    gp_delete: 'Delete',
    gp_delete_confirm: 'Delete this purchase?',
    gp_day_total: 'Day total',
    gp_paid_out: 'Paid out',
    gp_save: 'Save',
    gp_saving: 'Saving…',
    gp_gold_opening: 'Gold (opening)',
    gp_gold_bought: 'Gold bought',
    gp_gold_closing: 'Gold (closing)',
    gp_spent_today: 'Spent today',
    gp_gold_adjustments: 'Adjustments',
    gp_adjust_gold: 'Adjust gold',
    gp_gold_subtract: 'Subtract',
    gp_gold_reset: 'Reset total',
    gp_gold_subtract_amount: 'Amount to subtract',
    gp_gold_new_total: 'New total',
    gp_apply: 'Apply',
    gp_undo: 'Undo',
    gp_teor_calc: 'TEOR Calculator',
    gp_teor_water: 'Weight in water',
    gp_teor_actual: 'Actual weight',
    gp_default_value: 'default',
    gp_search_note: 'Search note #',
    // Loans module
    current_loan_balance: 'Outstanding Loan',
    make_loan_transaction: 'Make a Loan Transaction',
    disbursement: 'Disbursement',
    repayment: 'Repayment',
    add_loan_transaction: 'Add Loan Transaction',
    no_loan_transactions: 'No loan transactions yet',
    all_clients_loan_total: 'All Clients Loans',
    loan_statement: 'Loan Statement',
    outstanding_balances: 'Outstanding Balances',
    no_loans: 'No loans',
    edit_loan_transaction: 'Edit Loan Transaction',
    delete_loan_tx_confirm: 'Delete this loan transaction?',
    // Module picker
    module_receipts: 'Receipts',
    module_receipts_desc: 'Print receipts: custody, gold, pix, loans, pawn and more.',
    // Receipts module
    receipts: 'Receipts',
    receipts_desc: 'Pick a receipt type, fill the fields, then print.',
    receipt_type: 'Receipt Type',
    print_receipt: 'Print Receipt',
    fill_required_fields: 'Fill the required fields first',
    preview: 'Preview',
    preview_desc: 'This is exactly what will print (80mm).',
    optional: 'optional',
    rcpt_type_custodia: 'Custody',
    rcpt_type_guarda_ouro: 'Gold Storage',
    rcpt_type_liberacao_custodia: 'Custody Release',
    rcpt_type_pagamento: 'Payment',
    rcpt_type_pix: 'Pix',
    rcpt_type_recebido: 'Received',
    rcpt_type_encomenda: 'Order',
    rcpt_type_emprestimo: 'Loan',
    rcpt_type_penhor: 'Pawn',
    rcpt_type_juros_penhor: 'Pawn Interest',
    rcpt_type_compra_ouro: 'Gold Purchase',
    rcpt_f_cliente: 'Client',
    rcpt_f_saldo_atual: 'Current Balance',
    rcpt_f_ultima_retirada: 'Last Withdrawal',
    rcpt_f_ultimo_deposito: 'Last Deposit',
    rcpt_f_peso: 'Weight',
    rcpt_f_teor: 'Purity',
    rcpt_f_data: 'Date',
    rcpt_f_de: 'From',
    rcpt_f_para: 'To',
    rcpt_f_valor: 'Amount',
    rcpt_f_banco: 'Bank',
    rcpt_f_pecas: 'Pieces',
    rcpt_f_v_emprestado: 'Loaned Amount',
    rcpt_f_juros_pct: 'Interest',
    rcpt_f_juros_valor: 'Interest Amount',
    rcpt_f_vencimento: 'Due Date',
    rcpt_f_juros: 'Interest',
    rcpt_f_preco: 'Price',
    rcpt_f_total: 'Total',
    rcpt_f_pago: 'Paid',
    suggestion: 'Suggestion',
    use_suggestion: 'Use',
    editable: 'editable',
    rcpt_sign: 'SIGN',
    rcpt_footer_1: 'THANK YOU FOR YOUR PREFERENCE, COME AGAIN!',
    rcpt_footer_2: 'GOD IS FAITHFUL!',
    // Transaction type labels (used in PDF exports)
    withdrawal: 'Withdrawal',
    adjustment: 'Adjustment',
    transfer: 'Transfer',
  },
  'pt-BR': {
    brand_title: 'GL Compra de Ouro',
    customers: 'Clientes',
    search_placeholder: 'Pesquisar por nome, informações ou telefone',
    signed_in_as: 'Logado como',
    logout: 'Sair',
    current_balance: 'Saldo Atual',
    make_transaction: 'Fazer Transação',
    type: 'Tipo',
    deposit: 'Depósito',
    withdraw: 'Saque',
    amount: 'Valor',
    description: 'Descrição',
    description_placeholder: 'ex.: Depósito da venda de ouro',
    date: 'Data',
    add_transaction: 'Adicionar Transação',
    transaction_history: 'Histórico de Transações',
    no_transactions: 'Nenhuma transação ainda',
    no_customers: 'Nenhum cliente encontrado',
    select_customer: 'Selecione um cliente para ver detalhes',
    // Customers
    add_client: 'Adicionar Cliente',
    new_client: 'Novo Cliente',
    edit_client: 'Editar Cliente',
    name: 'Nome',
    email: 'E-mail',
    phone: 'Telefone',
    additional_info: 'Informações adicionais',
    cancel: 'Cancelar',
    create: 'Criar',
    save: 'Salvar',
    edit: 'Editar',
    delete: 'Excluir',
    delete_confirm: 'Excluir este cliente? Isso também removerá suas transações.',
    delete_tx_confirm: 'Excluir esta transação?',
    edit_transaction: 'Editar Transação',
    saving: 'Salvando…',
    invalid_amount: 'Valor inválido',
    all_clients_total: 'Saldo de todos os clientes',
    transaction_statement: 'Extrato de Transações',
    generated: 'Gerado',
    unknown_customer: 'Cliente Desconhecido',
    current_balances: 'Saldos Atuais',
    no_wallets: 'Sem carteiras',
    page: 'Página',
    of: 'de',
    no_transactions_found_for_customer: 'Nenhuma transação encontrada para este cliente.',
    amount: 'Valor',
    export_pdf: 'Exportar PDF',
    exporting: 'Exportando…',
    export_saldos: 'Exportar Saldos',
    saldos_statement: 'Saldos dos Clientes',
    no_clients_with_balance: 'Nenhum cliente com saldo diferente de zero.',
    // Histórico de Transações
    client: 'Cliente',
    currency: 'Moeda',
    balance: 'Saldo',
    all: 'Todos',
    today: 'Hoje',
    last_7_days: 'Últimos 7 dias',
    last_30_days: 'Últimos 30 dias',
    this_month: 'Este mês',
    all_time: 'Todo período',
    date_from: 'Data de',
    date_to: 'Data até',
    search: 'Buscar',
    loading: 'Carregando…',
    results: 'resultados',
    no_results: 'Sem resultados',
    close: 'Fechar',
    // Login
    sign_in_to_continue: 'Faça login para continuar',
    username: 'Usuário',
    password: 'Senha',
    sign_in: 'Entrar',
    demo_credentials: 'Credenciais de demonstração:',
    // Module picker
    choose_module: 'Escolha um módulo',
    choose_module_desc: 'Selecione a área do negócio em que você quer trabalhar.',
    module_custody: 'Custódia',
    module_custody_desc: 'Gerencie a custódia de dinheiro dos clientes (USD, EUR, SRD): depósitos, saques, saldos e histórico.',
    module_gold: 'Ouro',
    module_gold_desc: 'Controle o ouro físico por cliente e por teor. Depósitos, saques e histórico.',
    module_loans: 'Empréstimos',
    module_loans_desc: 'Gerencie empréstimos a clientes, juros e parcelamentos.',
    coming_soon: 'Em breve',
    back_to_modules: 'Voltar aos módulos',
    // Módulo de Ouro
    gold_holdings: 'Ouro do Cliente',
    no_gold_lots: 'Nenhum ouro registrado para este cliente',
    make_gold_transaction: 'Fazer Transação de Ouro',
    purity: 'Teor',
    purity_hint_deposit: 'Um novo teor cria um novo lote. Mesmo teor adiciona ao lote existente.',
    purity_hint_withdraw: 'Saques são feitos de um único lote. Teores nunca são misturados.',
    withdraw_from_lot: 'Sacar do lote',
    select_lot_placeholder: 'Selecione um lote...',
    select_lot_first: 'Selecione um lote para sacar.',
    insufficient_gold_in_lot: 'Ouro insuficiente neste lote.',
    invalid_purity: 'O teor deve estar entre 0 e 100.',
    lot: 'Lote',
    total: 'Total',
    unit: 'Unidade',
    all_clients_gold_total: 'Ouro de Todos os Clientes',
    gold_statement: 'Extrato de Ouro',
    // Módulo Compra de Ouro (livro de compras)
    module_gold_purchase: 'Compra de Ouro',
    module_gold_purchase_desc: 'Livro diário de compras: peso, preço, totais e pagamentos ao cliente com saldo acumulado.',
    module_kassa: 'Caixa',
    module_kassa_desc: 'Caixa diário: defina os saldos iniciais (USD/SRD/EUR) e registre pagamentos e recebimentos.',
    kassa_opening: 'Saldo Inicial',
    kassa_set_opening: 'Definir Saldo',
    kassa_not_set: 'não definido para este dia',
    kassa_saldo: 'Saldo',
    kassa_add_transaction: 'Adicionar Transação',
    kassa_pagamento: 'Pagamento',
    kassa_recebido: 'Recebido',
    kassa_add_line: 'Adicionar Linha',
    kassa_confirm: 'Confirmar',
    kassa_need_amount: 'Informe um valor em pelo menos uma moeda.',
    kassa_gold_tab: 'Ouro',
    kassa_gold_paid: 'Ouro pago',
    kg_other_day: 'Essa nota é de outro dia',
    kassa_close_title: 'Fechar Caixa',
    kassa_close_save: 'Salvar Fechamento',
    kassa_closed: 'Fechado',
    kassa_bill: 'Nota',
    kassa_count: 'Qtd',
    kassa_counted: 'Contado',
    kassa_difference: 'Diferença',
    kassa_unlock: 'Reabrir',
    kassa_reopen_confirm: 'Reabrir este dia para edição?',
    kassa_locked_note: 'Caixa fechado — reabra para fazer alterações.',
    prev_day: 'Dia anterior',
    next_day: 'Próximo dia',
    gold_purchase: 'Compra de Ouro',
    gp_today: 'Hoje',
    gp_opening_balance: 'Saldo Inicial',
    gp_closing_balance: 'Saldo Final',
    gp_set_opening: 'Definir saldo inicial',
    gp_exchange_rate: 'Taxa de Câmbio (USD → SRD)',
    gp_default_rate: 'Taxa padrão',
    gp_note: 'Nota #',
    gp_grams: 'Gramas',
    gp_price: 'Preço/g',
    gp_total_usd: 'Total USD',
    gp_total_srd: 'Total SRD',
    gp_rate: 'Taxa',
    gp_paid_usd: 'Pago USD',
    gp_paid_srd: 'Pago SRD',
    gp_paid_eur: 'Pago EUR',
    gp_add_row: 'Adicionar compra',
    gp_no_rows: 'Nenhuma compra neste dia ainda',
    gp_new_row: 'Nova',
    gp_edit: 'Editar',
    gp_confirm: 'Confirmar',
    gp_print: 'Imprimir',
    gp_delete: 'Excluir',
    gp_delete_confirm: 'Excluir esta compra?',
    gp_day_total: 'Total do dia',
    gp_paid_out: 'Pago',
    gp_save: 'Salvar',
    gp_saving: 'Salvando…',
    gp_gold_opening: 'Ouro (inicial)',
    gp_gold_bought: 'Ouro comprado',
    gp_gold_closing: 'Ouro (final)',
    gp_spent_today: 'Gasto hoje',
    gp_gold_adjustments: 'Ajustes',
    gp_adjust_gold: 'Ajustar ouro',
    gp_gold_subtract: 'Subtrair',
    gp_gold_reset: 'Redefinir total',
    gp_gold_subtract_amount: 'Quantidade a subtrair',
    gp_gold_new_total: 'Novo total',
    gp_apply: 'Aplicar',
    gp_undo: 'Desfazer',
    gp_teor_calc: 'Calculadora de Teor',
    gp_teor_water: 'Peso Molhado',
    gp_teor_actual: 'Peso Seco',
    gp_default_value: 'padrão',
    gp_search_note: 'Buscar nota #',
    // Módulo de Empréstimos
    current_loan_balance: 'Saldo Devedor',
    make_loan_transaction: 'Fazer Transação de Empréstimo',
    disbursement: 'Empréstimo',
    repayment: 'Pagamento',
    add_loan_transaction: 'Adicionar Transação',
    no_loan_transactions: 'Nenhuma transação de empréstimo ainda',
    all_clients_loan_total: 'Empréstimos de Todos os Clientes',
    loan_statement: 'Extrato de Empréstimos',
    outstanding_balances: 'Saldos Devedores',
    no_loans: 'Sem empréstimos',
    edit_loan_transaction: 'Editar Transação de Empréstimo',
    delete_loan_tx_confirm: 'Excluir esta transação de empréstimo?',
    // Seletor de módulos
    module_receipts: 'Recibos',
    module_receipts_desc: 'Imprimir recibos: custódia, ouro, pix, empréstimos, penhor e mais.',
    // Módulo de Recibos
    receipts: 'Recibos',
    receipts_desc: 'Escolha um tipo de recibo, preencha os campos e imprima.',
    receipt_type: 'Tipo de Recibo',
    print_receipt: 'Imprimir Recibo',
    fill_required_fields: 'Preencha os campos obrigatórios primeiro',
    preview: 'Pré-visualização',
    preview_desc: 'Isto é exatamente o que será impresso (80mm).',
    optional: 'opcional',
    rcpt_type_custodia: 'Custodia',
    rcpt_type_guarda_ouro: 'Guarda Ouro',
    rcpt_type_liberacao_custodia: 'Liberação de Custodia',
    rcpt_type_pagamento: 'Pagamento',
    rcpt_type_pix: 'Pix',
    rcpt_type_recebido: 'Recebido',
    rcpt_type_encomenda: 'Encomenda',
    rcpt_type_emprestimo: 'Emprestimo',
    rcpt_type_penhor: 'Penhor',
    rcpt_type_juros_penhor: 'Juros - Penhor',
    rcpt_type_compra_ouro: 'Compra de Ouro',
    rcpt_f_cliente: 'Cliente',
    rcpt_f_saldo_atual: 'Saldo Atual',
    rcpt_f_ultima_retirada: 'Última Retirada',
    rcpt_f_ultimo_deposito: 'Último Deposito',
    rcpt_f_peso: 'Peso',
    rcpt_f_teor: 'Teor',
    rcpt_f_data: 'Data',
    rcpt_f_de: 'De',
    rcpt_f_para: 'Para',
    rcpt_f_valor: 'Valor',
    rcpt_f_banco: 'Banco',
    rcpt_f_pecas: 'Peças',
    rcpt_f_v_emprestado: 'V. Emprestado',
    rcpt_f_juros_pct: 'Juros',
    rcpt_f_juros_valor: 'Valor Juros',
    rcpt_f_vencimento: 'Vencimento',
    rcpt_f_juros: 'Juros',
    rcpt_f_preco: 'Preço',
    rcpt_f_total: 'Total',
    rcpt_f_pago: 'PAGO',
    suggestion: 'Sugestão',
    use_suggestion: 'Usar',
    editable: 'editável',
    rcpt_sign: 'ASS',
    rcpt_footer_1: 'GRATO PELA PREFERÊNCIA, VOLTE SEMPRE!',
    rcpt_footer_2: 'DEUS É FIEL!',
    // Transaction type labels (used in PDF exports)
    withdrawal: 'Saque',
    adjustment: 'Ajuste',
    transfer: 'Transferência',
  },
};

export function LocaleProvider({ children }) {
  const [locale, setLocale] = useState('en');

  useEffect(() => {
    const saved = localStorage.getItem(LOCALE_KEY);
    if (saved && messages[saved]) setLocale(saved);
  }, []);

  useEffect(() => {
    localStorage.setItem(LOCALE_KEY, locale);
  }, [locale]);

  const t = (key) => {
    const dict = messages[locale] || messages.en;
    return dict[key] || key;
  };

  // Always-Portuguese translator. PDF exports use this so printed documents
  // stay in Portuguese regardless of the UI language toggle.
  const tPt = (key) => {
    const dict = messages['pt-BR'] || messages.en;
    return dict[key] || key;
  };

  const value = useMemo(() => ({ locale, setLocale, t, tPt, messages }), [locale]);

  return <LocaleContext.Provider value={value}>{children}</LocaleContext.Provider>;
}

export function useLocale() {
  const ctx = useContext(LocaleContext);
  if (!ctx) throw new Error('useLocale must be used within a LocaleProvider');
  return ctx;
}
